import { registerWidget, IWidget, IWidgetDefinition, SubFilter } from '../../common/core';
import { IFuseSubFiltersSettings } from './fuse-subfilters.settings';
import { SubFiltersWidgetDefinition, SubFiltersData } from '../subfilters.widget/subfilters.widget';

const template = require('./fuse-subfilters.html');
const styles = require('./fuse-subfilters.scss').toString();

class FuseSubFiltersData extends SubFiltersData {
    filters: SubFilter[];
    selectedFilters: string;

    constructor(public widget: IWidget<FuseSubFiltersData, IFuseSubFiltersSettings, null>) {
        super(widget)
    }

    beforeSearch() {
        super.beforeSearch();
        this.selectedFilters = this.filters.map((filter: SubFilter) => filter.label).join(' • ');
    }
}

const FuseSubFiltersWidgetDefinition: IWidgetDefinition<FuseSubFiltersData, IFuseSubFiltersSettings, null> = {
    ...SubFiltersWidgetDefinition,
    init(widget) {
        widget.data = new FuseSubFiltersData(widget);
    },
    template,
    styles,
};

registerWidget('fuse-subfilters', FuseSubFiltersWidgetDefinition);